import { useAudio } from '@/contexts/audio-context';

export function useMusic() {
	const {
		isMusicEnabled,
		isMusicPlaying,
		playMusic,
		pauseMusic,
		toggleMusic,
		setMusicEnabled,
		isSoundEffectsEnabled,
		toggleSoundEffects,
		setSoundEffectsEnabled,
	} = useAudio();

	return {
		isPlaying: isMusicPlaying,
		play: playMusic,
		pause: pauseMusic,
		toggle: toggleMusic,
		isMusicOn: isMusicEnabled,
		toggleMusicOn: () => {
			void toggleMusic();
		},
		setMusicOn: (on: boolean) => {
			void setMusicEnabled(on);
		},
		isGameSoundOn: isSoundEffectsEnabled,
		toggleGameSound: toggleSoundEffects,
		setGameSound: setSoundEffectsEnabled,
	};
}
